var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLocalShipping(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 5.33335H11.3332V2.66669H1.99984C1.2665 2.66669 0.666504 3.26669 0.666504 4.00002V11.3334H1.99984C1.99984 12.44 2.89317 13.3334 3.99984 13.3334C5.1065 13.3334 5.99984 12.44 5.99984 11.3334H9.99984C9.99984 12.44 10.8932 13.3334 11.9998 13.3334C13.1065 13.3334 13.9998 12.44 13.9998 11.3334H15.3332V8.00002L13.3332 5.33335ZM3.99984 12.3334C3.4465 12.3334 2.99984 11.8867 2.99984 11.3334C2.99984 10.78 3.4465 10.3334 3.99984 10.3334C4.55317 10.3334 4.99984 10.78 4.99984 11.3334C4.99984 11.8867 4.55317 12.3334 3.99984 12.3334ZM12.9998 6.33335L14.3065 8.00002H11.3332V6.33335H12.9998ZM11.9998 12.3334C11.4465 12.3334 10.9998 11.8867 10.9998 11.3334C10.9998 10.78 11.4465 10.3334 11.9998 10.3334C12.5532 10.3334 12.9998 10.78 12.9998 11.3334C12.9998 11.8867 12.5532 12.3334 11.9998 12.3334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocalShipping);
export default __webpack_public_path__ + "static/media/ic_local_shipping.4b7d0a8ec1b6567e574f4bd91da1f39a.svg";
export { ForwardRef as ReactComponent };